var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParseStarsToBold = exports.hasStar = exports.replaceStars = void 0;

var react_1 = __importDefault(require("react"));

var any_1 = require("../elements/any");

var parse_new_lines_1 = require("./parse-new-lines");

exports.replaceStars = function (children) {
  var result = [];
  react_1.default.Children.forEach(children, function (child) {
    if (child && typeof child === 'string') {
      var findStar = child.split(/\*(.*)/);
      var hasStar = findStar.length > 1;

      if (!hasStar) {
        result.push(findStar[0]);
        return;
      }

      var findSecondStar = findStar[1].split(/\*(.*)/);
      var hasSecondStar = findSecondStar.length > 1;

      if (!hasSecondStar) {
        result.push.apply(result, _toConsumableArray(findStar));
        return;
      }

      result.push(findStar[0], react_1.default.createElement("b", {
        key: findStar[0]
      }, findSecondStar[0]));
      var remaining = exports.replaceStars(findSecondStar[1]);
      result.push.apply(result, _toConsumableArray(remaining));
    } else if (child) {
      result.push(child);
    }
  });
  return result;
};

exports.hasStar = function (children) {
  var childArray = react_1.default.Children.toArray(children);
  return childArray && Array.isArray(childArray) && childArray.length > 0 && typeof childArray[0] === 'string' && childArray[0].indexOf('*') >= 0;
};

exports.ParseStarsToBold = function (props) {
  return react_1.default.createElement(any_1.Any, {
    is: props.is,
    polyPreset: true,
    wheel: props.wheel
  }, exports.replaceStars(parse_new_lines_1.replaceNewlines(props.children)));
};